module.exports = __webpack_public_path__ + "img/gain-item2.91ea3f4b.png";